module.exports = __webpack_public_path__ + "assets/b3c99a4e4ae4ad61a3aa871b6c416c93.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/channels/hu/6.png
// module id = 344
// module chunks = 1